export const PUBLIC_SETTING_DEFAULTS = {
  grid_display_mode: 'artistic',
  grid_reflection_enabled: false,
  annual_copyright_credit_en: '',
  annual_copyright_credit_es: ''
}

export function normalizePublicSettings (record = {}) {
  return {
    grid_display_mode: record.grid_display_mode || PUBLIC_SETTING_DEFAULTS.grid_display_mode,
    grid_reflection_enabled: record.grid_reflection_enabled === true || Number(record.grid_reflection_enabled) === 1,
    annual_copyright_credit_en: record.annual_copyright_credit_en || '',
    annual_copyright_credit_es: record.annual_copyright_credit_es || ''
  }
}

export function previewAnnualCopyright (template, year, artist = 'Artist name') {
  const values = { year: String(year), artist }
  return String(template || '').replace(/\{(year|artist)\}/g, (match, key) => values[key]).trim()
}



// WEBPACK FOOTER //
// ./src/utils/publicWebsiteSettings.js